import { Check } from "lucide-react";
import { useEffect, useState } from "react";

export const SuccessCheck = () => {
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(true);
		}, 500);

		return () => clearTimeout(timer);
	}, []);

	return (
		<div className="relative mb-8 flex h-80 w-80 items-center justify-center">
			{/* Elementos decorativos simples ao redor do check */}
			<div className="text-success animate-float absolute left-8 top-12 opacity-60">
				<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
					<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
				</svg>
			</div>

			<div
				className="text-success animate-float absolute bottom-16 right-12 opacity-50"
				style={{ animationDelay: "1.5s" }}
			>
				<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
					<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
				</svg>
			</div>

			<div
				className="text-success absolute right-8 top-20 animate-pulse opacity-40"
				style={{ animationDelay: "2s" }}
			>
				<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
					<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
				</svg>
			</div>

			{/* Central check circle */}
			<div className="relative">
				{/* Outer glow ring */}
				<div className="bg-gradient-success animate-glow-pulse absolute inset-0 h-32 w-32 rounded-full opacity-30 blur-md"></div>

				{/* Main circle */}
				<div className="bg-success shadow-success relative flex h-28 w-28 items-center justify-center rounded-full">
					<Check
						className={`duration-800 h-16 w-16 text-white transition-all ${
							isVisible ? "animate-check-appear" : "scale-0 opacity-0"
						}`}
						strokeWidth={4}
					/>
				</div>
			</div>
		</div>
	);
};
